import { createContext, useContext } from 'react';
import { WorkflowContextType } from './index.functions';
export const WorkflowContext = createContext<WorkflowContextType | undefined>({} as WorkflowContextType);

export function useWorkflowContext() {
    const context = useContext(WorkflowContext);
    if (!context) {
        throw new Error('useWorkflowContext must be used within a WorkflowContextProvider');
    }
    return context;
}
